import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

export default function ProtectedRoute() {
  const { currentUser, isLoading } = useAuth();
  const { t } = useTranslation();

  if (isLoading)
    return (
      <div
        style={{
          minHeight: '100dvh',
          display: 'grid',
          placeItems: 'center',
          color: 'var(--surface)',
        }}
      >
        {t('loading')}
      </div>
    );
  if (!currentUser) return <Navigate to="/login" replace />;

  return <Outlet />;
}
